import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCol,{attrs:{"cols":"12"}},[_c('new-image-upload',{staticClass:"file-upload__image",attrs:{"imgUrl":_vm.about_photo && _vm.about_photo.path,"maxSize":_vm.imageSize},on:{"fileSelected":_vm.uploadPhoto}})],1),_c('WrappingComponent',{attrs:{"settings":_vm.settings,"formData":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }